import { Menu, Text } from "@mantine/core";
import { useState } from "react";

import type { GuideOption } from "../logic-builder";

import { useGuideStore } from "../store";
import { GuideMenuButton } from "./GuideMenuButton";
import classes from "./styles.module.css";

interface GuideMenuProps {
    defaultValue?: string;
    label: string;
    options: GuideOption[];
    onClick: (selectedOption: GuideOption) => void;
    validationError?: string;
}

export function GuideMenu({ label, defaultValue, options, validationError, onClick }: GuideMenuProps) {
    const { selectedOptions, setSelectedOptions } = useGuideStore();
    const [menuOpened, setMenuOpened] = useState(false);

    const menuOptions = options.map((option) => (
        <Menu.Item
            data-testid={`guide-menu-${label}-${option.value}`}
            key={`guide-menu-${label}-${option.value}`}
            onClick={() => {
                setSelectedOptions({ ...selectedOptions, [label]: option });
                onClick(option);
            }}
        >
            <Text size="xs">{option.label}</Text>
        </Menu.Item>
    ));

    return (
        <Menu
            closeOnClickOutside
            position="bottom-start"
            opened={menuOpened}
            onChange={setMenuOpened}
            zIndex="var(--mantine-priority-high)"
        >
            <Menu.Target>
                <GuideMenuButton
                    label={validationError ?? selectedOptions[label]?.label ?? defaultValue ?? label}
                    menuOpened={menuOpened}
                    validationError={validationError}
                />
            </Menu.Target>
            <Menu.Dropdown maw="17.5rem" className={classes.menuDropdown}>
                {menuOptions}
                {menuOptions.length === 0 && <Menu.Item>No options available</Menu.Item>}
            </Menu.Dropdown>
        </Menu>
    );
}
